import React, { useEffect }           from 'react';
import { useDispatch, useSelector }   from 'react-redux';

import Messages                       from 'pu-react/components/Messages';
import BomHeader                      from './header/bom_header';
import Workbook                       from './workbook/workbook';

import { selectDataForImportView }    from 'product_tabs/tab_parts/selector/selectors';

const BomImport = (props) => {

  const {
    bom_parameters,
    messages,
    validator,
  } = props;

  const {
    name,
    revision,
    board_qtys,
    header,
    first_row,
    ref_des_separator,
    ref_des_range_separator,
    workbook,
  } = useSelector(selectDataForImportView);

  return (
    <>
      <div id="boms">
        <Messages messages={messages} />
        <BomHeader 
          name={name}
          revision={revision}
          board_qtys={board_qtys}
          header={header}
          first_row={first_row}
          validator={validator}/>
        <hr/>
        <Workbook 
          ref_des_separator={ref_des_separator}
          ref_des_range_separator={ref_des_range_separator}
          header={header}
          first_row={first_row}
          bom_parameters={bom_parameters}
          workbook={workbook}/>
      </div>
    </>
  )
}

export default BomImport;